import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { httpResilienceInterceptor } from '@core/interceptors/http-resilience.interceptor';
import { clientVersionInterceptor } from '@core/interceptors/client-version.interceptor';

registerLocaleData(localeEs, 'es-AR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([clientVersionInterceptor, authInterceptor, httpResilienceInterceptor]),
    ),
    {
      provide: LOCALE_ID,
      useValue: 'es-AR',
    },
  ],
};
